module.exports = __webpack_public_path__ + "img/male_AP_01.8113d80e.png";